import React, {useEffect, useState} from 'react';
import ModalContainer from '../../../uiToolkit/ModalContainer';
import TextInput from '../../../uiToolkit/Inputs/TextInput';
import Button from '../../../uiToolkit/Buttons/Button';
import {POST_TITLE_MAX_LENGTH} from '../../../data/models/Posts/Post';
import {postsText} from '../postsText';
import styles from './RenamePostMediaModal.module.css';

interface Props {
  initialName?: string;
  isLoading: boolean;
  onCancel: () => void;
  onSave: (name: string) => void;
}

const RenamePostMediaModal = React.memo(
  ({initialName, isLoading, onCancel, onSave}: Props) => {
    const [name, setName] = useState(initialName ?? '');

    useEffect(() => {
      if (initialName !== undefined) {
        setName(initialName);
      }
    }, [initialName]);

    return (
      <ModalContainer onClose={onCancel} className={styles.modal}>
        <div className={styles.container}>
          <h3 className={styles.title}>{postsText.renameMediaTitle}</h3>

          <p className={styles.fieldTitle}>
            {postsText.mediaName}
            <span className="MandatoryIndicator">*</span>
          </p>
          <TextInput
            value={name}
            placeholder={postsText.mediaNamePlaceholder}
            onChange={setName}
            maxCharacters={POST_TITLE_MAX_LENGTH}
          />

          <div className={styles.footer}>
            <Button title={postsText.cancel} onClick={onCancel} uiType="text" />
            <Button
              title={postsText.save}
              onClick={() => onSave(name)}
              uiType="action"
              isLoading={isLoading}
              disabled={!name}
            />
          </div>
        </div>
      </ModalContainer>
    );
  },
);

export default RenamePostMediaModal;
